// owner/ui/States.js — loading, error and empty states for the owner screens.
// House rule (OWNER_EXPERIENCE_MAP, §2 decision 15): a slow or failed load never looks like a real zero or
// "no data". Loading is a grey skeleton, a failure says so and offers a retry, and nothing stale is shown.

import React from 'react';
import useLanguage from '../../hooks/useLanguage';
import Icon from './Icon';

export const SkeletonBlocks = ({ hero = false, blocks = 2 }) => (
  <div aria-busy="true">
    {hero && <div className="o-sk o-sk-hero" />}
    {Array.from({ length: blocks }).map((_, i) => <div key={i} className="o-sk o-sk-block" />)}
  </div>
);

export const ErrorState = ({ title, onRetry }) => {
  const { t } = useLanguage();
  return (
    <div className="o-center-state" role="alert">
      <span className="o-glyph err"><Icon name="alert" /></span>
      <h2>{title}</h2>
      <p>{t('ownerApp.common.loadErrorHint')}</p>
      {onRetry && (
        <button type="button" className="o-btn o-btn-primary" onClick={onRetry}>
          <Icon name="refresh" size="sm" />{t('states.retry')}
        </button>
      )}
    </div>
  );
};

/** A failed part of a screen that otherwise loaded: says so in place, never a blank or a zero. */
export const InlineError = ({ text, onRetry }) => {
  const { t } = useLanguage();
  return (
    <div className="o-inline-error" role="alert">
      <span>{text}</span>
      {onRetry && <button type="button" className="o-btn o-btn-outline" onClick={onRetry}>{t('states.retry')}</button>}
    </div>
  );
};

export const EmptyState = ({ icon = 'calendar', title, hint, action }) => (
  <div className="o-center-state">
    <span className="o-glyph"><Icon name={icon} /></span>
    <h2>{title}</h2>
    {hint && <p>{hint}</p>}
    {action}
  </div>
);
